<template>
  <div class="w-20 flex items-center flex-shrink-0 transition-all duration-300">
    <div class="h-full flex-grow flex-shrink" @click="onToggleMenu('')"></div>
    <div
      class="fixed left-6 z-10 flex flex-col gap-3"
      :style="{
        top: 'calc(3.75rem + ((100vh - 3.75rem) / 2))',
        transform: 'translateY(-50%)'
      }"
    >
      <div
        v-for="item in menuOptions"
        :key="item.value"
        class="h-12 w-12 flex items-center justify-center text-center rounded border cursor-pointer"
        :class="{
          'border-light-purple bg-light-purple': menu === item.value,
          'border-slate-400 bg-pure-white': menu !== item.value
        }"
        :title="item.value"
        @click="onToggleMenu(item.value)"
      >
        <BlIcon
          :icon="item.icon"
          class="h-8 w-8"
          :color="menu === item.value ? 'white' : 'slate-8'"
        />
      </div>
    </div>
    <div
      class="fixed z-10 min-w-80 py-px bg-pure-white border border-slate-400 rounded-xl shadow-lg overflow-y-auto"
      :class="{ 'left-20': menu, '-left-140': !menu }"
      :style="{
        top: 'calc(3.75rem + ((100vh - 3.75rem) / 2))',
        transform: 'translateY(-50%)',
        maxHeight: 'calc(100vh - 3.75rem - 3rem)'
      }"
    >
      <TableOfContents
        v-if="menu === 'View table of contents'"
        class="w-116"
        :sectionFocusedId="sectionFocusedId"
        @close="onToggleMenu('')"
        @change-focus-id="$emit('change-focus-id', $event)"
      />
      <ShareReport
        v-if="menu === 'Share report'"
        class="w-80"
        @close="onToggleMenu('')"
      />
      <DownloadReport
        v-if="menu === 'Download report'"
        class="w-80"
        @close="onToggleMenu('')"
      />
    </div>

    <BlBackdrop
      v-if="deleteOpened"
      title="Delete report"
      label="Delete"
      :description="
        `You are about to delete report ${report.name}. Are you sure you want to proceed? This action is irreversible.`
      "
      type="error"
      empty
      :submitLoading="deleteLoading"
      @backdrop-close="deleteOpened = false"
      @backdrop-action="onDelete"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import TableOfContents from "./helper/TableOfContents.vue";
import ShareReport from "./helper/ShareReport.vue";
import DownloadReport from "./helper/DownloadReport.vue";

import BlIcon from "../BlIcon.vue";
import BlBackdrop from "../BlBackdrop.vue";

export default {
  name: "ParentReportHelper",
  props: {
    sectionFocusedId: { type: Number }
    // @change-focus-id
  },
  components: {
    TableOfContents,
    ShareReport,
    DownloadReport,
    BlIcon,
    BlBackdrop
  },
  data() {
    return {
      menu: "",
      deleteOpened: false,
      deleteLoading: false
    };
  },
  computed: {
    ...mapGetters(["currentUser", "report"]),
    menuOptions() {
      const base = [
        { value: "View table of contents", icon: "list" },
        { value: "Share report", icon: "share" },
        { value: "Download report", icon: "download" }
      ];
      if (this.currentUser.id) {
        return [...base, { value: "Delete report", icon: "delete" }];
      }
      return base;
    }
  },
  watch: {
    deleteOpened(val) {
      if (!val) this.menu = "";
    }
  },
  mounted() {},
  methods: {
    ...mapActions(["deleteReport"]),
    onToggleMenu(val) {
      if (val === this.menu) this.menu = "";
      else if (!this.menu) this.menu = val;
      else {
        this.menu = "";
        setTimeout(() => {
          this.menu = val;
        }, 150);
      }
      if (val === "Delete report") {
        this.deleteOpened = true;
      }
    },
    async onDelete() {
      const data = {
        slug: this.report.slug,
        report_name: this.report.name
      };
      const clientId = this.report.client_id;
      this.deleteLoading = true;
      const { success } = await this.deleteReport(data);
      this.deleteLoading = false;
      if (!success) return;
      this.deleteOpened = false;
      this.menu = "";
      this.$router.push(`/clients/${clientId}/report`);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/reports/ParentReportHelper.vue